import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./style/index.css";
import "./style/scrollbar.css";
import "./style/quill.css";
import Crashlitics from "./utils/Crashlitics.ts";
import "./utils/stringUtils";

Crashlitics.init();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
